import {Modal as BaseModal} from "@mui/material"
import {Button} from "component/button"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

export const ModalConfirm = ({
                                icon,
                                title,
                                description,
                                handleConfirm,
                                type,
                                ...props
                             }) => {

   const handleClose = (e) => {
      e.stopPropagation()
      props?.onClose()
   }

   const onDelete = (e) => {
      handleConfirm()
      handleClose(e)
   }

   return (
      <>
         <Modal
            aria-labelledby="unstyled-modal-title"
            aria-describedby="unstyled-modal-description"
            open={!!props?.open}
            onClose={handleClose}
            slots={{backdrop: StyledBackdrop}}
         >
            <ModalContent
               onClick={(e) => e.stopPropagation()}
               className="p-6 flex flex-col items-center !gap-0 m-2"
            >
               <div className="mb-2">{icon}</div>
               <div className="font-semibold text-xl mb-4">{title}</div>
               <div className="text-sm font-normal text-center">{description}</div>
               <div className="flex justify-center gap-2 mt-6">
                  <Button
                     className="h-8 w-[110px]"
                     appearance="ghost"
                     onClick={handleClose}
                  >
                     Đóng
                  </Button>
                  {props?.confirm === true &&
                  <Button
                     className="h-8 w-[110px]"
                     appearance={type}
                     onClick={onDelete}
                  >
                     {type === "danger" ? "Xóa" : "Xác nhận"}
                  </Button>
                  }
               </div>
            </ModalContent>
         </Modal>
      </>
   )
}

const Backdrop = React.forwardRef((props, ref) => {
   const {open, setOpen, className, ...other} = props
   return (
      <div
         className={`${open ? "base-Backdrop-open" : ""}, ${className}`}
         ref={ref}
         {...other}
         onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
         }}
      />
   )
})

const Modal = styled(BaseModal)`
  position: fixed;
  z-index: 1300;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

Backdrop.propTypes = {
   className: PropTypes.string.isRequired,
   open: PropTypes.bool,
}

const StyledBackdrop = styled(Backdrop)`
  z-index: -1;
  position: fixed;
  inset: 0;
  background-color: rgb(0 0 0 / 0.3);
  -webkit-tap-highlight-color: transparent;
`

const ModalContent = styled.div`
  outline: none;
  position: relative;
  overflow: hidden;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 2px 4px 10px 0px #0000001A;
  padding: 24px;
`
